// Tastaturregeln der Radiogruppe von <Segmented choice> als reine Funktionen (node --test ohne DOM, wie focusTrap.ts).

export interface ChoiceOption { value: string; disabled?: boolean }

/** Der eine Tab-Halt der Gruppe: das gewählte, aktive Segment, sonst das erste aktive (-1: alle gesperrt). */
export function radioTabStop(options: readonly ChoiceOption[], value: string): number {
  const gewaehlt = options.findIndex(o => o.value === value && !o.disabled)
  return gewaehlt >= 0 ? gewaehlt : options.findIndex(o => !o.disabled)
}

/** Wohin springt eine Pfeiltaste von `index` aus? Rechts/unten = weiter, links/oben = zurück, ringsum, gesperrte Segmente
 *  übersprungen. `null`: keine Pfeiltaste oder kein anderes aktives Segment (der Aufrufer lässt die Taste dann durch). */
export function radioNext(options: readonly ChoiceOption[], index: number, key: string): number | null {
  const step = key === 'ArrowRight' || key === 'ArrowDown' ? 1 : key === 'ArrowLeft' || key === 'ArrowUp' ? -1 : 0
  if (step === 0) return null
  for (let i = 1; i < options.length; i++) {
    const next = (index + step * i + options.length * i) % options.length
    if (!options[next].disabled) return next
  }
  return null
}
